import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Tracking from "./pages/Tracking";
import About from "./pages/About";
import Contact from "./pages/Contact";
import DispatcherLogin from "./pages/DispatcherLogin";
import DriverLogin from "./pages/DriverLogin";
import DispatcherDashboard from "./pages/DispatcherDashboard";
import DriverDashboard from "./pages/DriverDashboard";
import SFTPConfig from "./pages/SFTPConfig";
import SFTPInbound from "./pages/SFTPInbound";
import AdminPanel from "./pages/AdminPanel";
import AdminLogin from "./pages/AdminLogin";
import CustomerLogin from "./pages/CustomerLogin";
import CustomerDashboard from "./pages/CustomerDashboard";
import HomeV2 from "./pages/HomeV2";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public routes with header/footer */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <Home />
                <Footer />
              </>
            }
          />
          <Route
            path="/services"
            element={
              <>
                <Header />
                <Services />
                <Footer />
              </>
            }
          />
          <Route
            path="/tracking"
            element={
              <>
                <Header />
                <Tracking />
                <Footer />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <Header />
                <About />
                <Footer />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                <Header />
                <Contact />
                <Footer />
              </>
            }
          />

          {/* New design preview (self-contained header/footer) */}
          <Route path="/v2" element={<HomeV2 />} />

          {/* Dispatch system routes - no header/footer */}
          <Route path="/dispatcher/login" element={<DispatcherLogin />} />
          <Route path="/dispatcher/dashboard" element={<DispatcherDashboard />} />
          <Route path="/driver/login" element={<DriverLogin />} />
          <Route path="/driver/dashboard" element={<DriverDashboard />} />
          <Route path="/sftp-config" element={<SFTPConfig />} />
          <Route path="/sftp-inbound" element={<SFTPInbound />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/customer/login" element={<CustomerLogin />} />
          <Route path="/customer/dashboard" element={<CustomerDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
